export default __webpack_public_path__ + "static/media/goshen41.acc27216.jpg";